import { createFeatureSelector, createSelector } from '@ngrx/store';
import { InAppNotificationPreferencesState } from 'src/app/in-app-notifications/store/in-app-notification-preferences.state';

export const inAppNotificationPreferencesFeatureKey = 'inAppNotificationPreferences';
export const inAppNotificationPreferencesFeature = createFeatureSelector<InAppNotificationPreferencesState>(
    inAppNotificationPreferencesFeatureKey
);

export const selectLoading = createSelector(inAppNotificationPreferencesFeature, (state) => state.loading);
export const selectInAppNotificationPreferences = createSelector(
    inAppNotificationPreferencesFeature,
    (state) => state.inAppNotificationPreferences
);
